"use client"

import { useState } from "react"
import { Button, Snackbar, Alert } from "@mui/material"
import fetchOrThrow from '../util/fetchOrThrow';

const RemoveDialog = ({ open, endpoint, itemId, onResult }) => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const handleRemove = async () => {
    if (loading) return

    setLoading(true)
    setErrorMessage(null) // Resetar mensagens de erro anteriores

    try {
      await fetchOrThrow(`/api/${endpoint}/${itemId}`, {
        method: "DELETE",
      })
      onResult(true)
    } catch (error) {
      console.error("Erro ao remover:", error)

      // Capturar mensagem de erro amigável
      const message = error.message.includes("<!DOCTYPE html>")
        ? "Erro interno do servidor"
        : error.message

      setErrorMessage(message)
      onResult(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {/* Snackbar de Confirmação */}
      <Snackbar
        open={open && !errorMessage}
        autoHideDuration={6000}
        onClose={() => onResult(false)}
        message="Confirmar remoção?"
        sx={{
          zIndex: 1400,
          bottom: { xs: 80, md: 24 },
          pointerEvents: "auto",
        }}
        action={
          <Button
            size="small"
            color="error"
            onClick={handleRemove}
            disabled={loading}
            sx={{
              height: "auto",
              marginTop: 0,
              marginBottom: 0,
              pointerEvents: "auto",
              zIndex: 1,
            }}
          >
            {loading ? "Removendo..." : "Remover"}
          </Button>
        }
      />

      {/* Snackbar de Erro */}
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={() => setErrorMessage(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="error"
          onClose={() => setErrorMessage(null)}
          sx={{ width: '100%' }}
        >
          {errorMessage || "Falha ao remover item"}
        </Alert>
      </Snackbar>
    </>
  )
}

export default RemoveDialog